import React, { Component, Fragment } from 'react';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import { Grid, TextField, Tooltip } from '@material-ui/core';
import { onCheckFormPermission } from '../../utils_v2';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { trackActivity } from '../../utils/mixpanel';
import SaveAltIcon from "@material-ui/icons/SaveAlt"
import GetAppIcon from '@material-ui/icons/GetApp';
const SortableItem = SortableElement((props) => {
  const handleDownload = (fileUrl) => {
    let urlParts = fileUrl.split('/');
    let fileName = urlParts[urlParts.length - 1].split('?')[0];
    let link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
	return(
		<li className="list-inline-item sort-picture-item" style={{width: '225px', height:'208px', zIndex:9, border:'groove 1px', borderColor:'lightgray',margin:'10px',padding:'2px'}}>
			<div className="dropped-pic-card" style={{backgroundSize:'cover',backgroundImage: "url(" + props.item.thumbnail_image + ")"}}>
				<div className="dropped-picture-cta">
					<>
					<span onClick={(e) => {e.preventDefault(); e.stopPropagation(); props.updateSlider();}}>
						<Tooltip title='View'>
						  <VisibilityIcon color="primary" fontSize='small' onClick={() => trackActivity('Project Management', {page_title: 'Inspection Pictures', event_type: 'Item Clicked', event_desc:'Clicked on View Image Icon', form_info: props?.formInfo})}/>
						</Tooltip>	
					</span>
					<span>
						<Tooltip title='Download'>
						  <GetAppIcon color='primary' fontSize='small' onClick={() => handleDownload(props.item.image)}/>
						</Tooltip>	
					</span>
					</>
					{onCheckFormPermission(props.formInfo) ?
						<Fragment>
							<span onClick={() => props.onEditInspection()}>
								<Tooltip title='Edit'>
								  <EditIcon color="primary" fontSize='small' onClick={() => trackActivity('Project Management', {page_title: 'Inspection Pictures', event_type: 'Item Clicked', event_desc:'Clicked on Edit Image Icon', form_info: props?.formInfo})}/>
								</Tooltip>	
							</span>
							<span onClick={() => props.onRemoveInspection()}>
								<Tooltip title='Delete'>
								  <DeleteOutlineIcon color="secondary" fontSize='small' onClick={() => trackActivity('Project Management', {page_title: 'Inspection Pictures', event_type: 'Item Clicked', event_desc:'Clicked on Delete Image Icon', form_info: props?.formInfo})} style={{cursor:'pointer'}}/>
								</Tooltip>	
							</span>
						</Fragment>:null
					}
				</div>
			</div>
		</li>
	)
});

const SortableList = SortableContainer(({items, onRemoveInspection, onEditInspection, updateSlider, formInfo, pageTitle}) => {
  return (
    <ul className="list-inline inspection-picture-list">
      {items.map((item, index) => (
        <SortableItem
			formInfo={formInfo}
			key={`item-${item.id}`}
			index={index}
			item={item}
			updateSlider={() => updateSlider(index)}
			onRemoveInspection={() => onRemoveInspection(item)}
			onEditInspection={() => onEditInspection(item)}
			pageTitle={pageTitle}
		/>
      ))}
    </ul>
  );
});
class SortTechList extends Component {
  render() {
    return <SortableList
			formInfo={this.props.formInfo}
			axis="xy"
			distance={1}
			items={this.props.items}
			onSortEnd={this.props.onSortEnd}
			updateSlider={(index) => this.props.updateSlider(index)}
			onRemoveInspection={(item) => this.props.onRemoveInspection(item)}
			onEditInspection={(item) => this.props.onEditInspection(item)}
		/>;
  }
}
export default SortTechList;